import type { UserDTO } from '@klangio/ai2notes-ts-client';
import { createContext } from 'react';

export interface IUserContextValue {
  user?: UserDTO;
  numberOfTickets: number;
  hasSubscription: boolean;
  hasTicketsForUse: boolean;
  hasSubscriptionTickets: boolean;
  isLoadingUserCompleted: boolean;
  logout: () => void;
  refresh: () => Promise<UserDTO>;
}

export const defaultUserContextValue: IUserContextValue = {
  user: null,
  hasSubscription: false,
  hasTicketsForUse: false,
  hasSubscriptionTickets: false,
  numberOfTickets: 0,
  isLoadingUserCompleted: false,
  logout: () => () => {},
  refresh: () => new Promise<UserDTO>(() => {}),
};

const UserContext = createContext<IUserContextValue>(defaultUserContextValue);

export default UserContext;
